import "../searchResults/searchResults.scss";
import { useSearch } from "./hooks/useSearch";
import SearchInput from "./components/SearchInput";
import SearchDropdown from "./components/SearchDropdown";

const SearchResults = () => {
    const {
        query,
        setQuery,
        searchResults,
        searchHistory,
        isSearchOpen,
        searchRef,
        handleOpenSearch,
        handleSearchSubmit,
        handleSelectUser,
        handleHistoryClick,
        clearHistory,
        removeHistoryItem,
    } = useSearch();

    return (
        <div className="search" ref={searchRef}>
            <SearchInput 
                query={query} 
                setQuery={setQuery} 
                onFocus={handleOpenSearch}
                onKeyDown={handleSearchSubmit}
            />

            {isSearchOpen && (
                <SearchDropdown 
                    query={query}
                    searchResults={searchResults}
                    searchHistory={searchHistory}
                    onSelect={handleSelectUser}
                    onHistoryClick={handleHistoryClick} 
                    onClearHistory={clearHistory}
                    onRemoveHistoryItem={removeHistoryItem}
                />
            )}
        </div>
    );
};

export default SearchResults;